import React, { useRef, useState } from "react";
import { AdSettingClassified } from "../../../../types/main-types/mainTypes";
import {
  PREMIUM_AD_DAYS,
  PREMIUM_AD_PRICE,
  STANDARD_AD_DAYS,
  STANDARD_AD_PRICE,
} from "../../../../configs/limits/boostLimits";
import {
  boostPremiumClassified,
  boostStandardClassified,
} from "../../../../services/main-service/mainService";
import {
  toastError,
  toastSuccess,
  toastWarning,
} from "../../../../utils/toast";

interface AdBoostPopupProps {
  adDetails: AdSettingClassified;
}

function AdBoostPopup({ adDetails }: AdBoostPopupProps) {
  const boostTypeList = [
    {
      id: 1,
      boostType: "standard",
      title: "Standard Ad Boost",
      boostPrice: STANDARD_AD_PRICE,
      boostDays: STANDARD_AD_DAYS,
    },
    {
      id: 2,
      boostType: "premium",
      title: "Premium Ad Boost",
      boostPrice: PREMIUM_AD_PRICE,
      boostDays: PREMIUM_AD_DAYS,
    },
  ];
  let [boostType, setBoostType] = useState<string>(adDetails.boost_type);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  function handleBoostTypeChange(
    e: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) {
    if (e.target.checked) {
      setBoostType(type);
    } else {
      setBoostType("");
    }
  }

  async function handleAdBoost() {
    let payload = { classified_id: adDetails.id };
    try {
      if (boostType === "premium") {
        const premiumBoostData = await boostPremiumClassified(payload);
        toastSuccess("Your Premium Boost request has been sent successfully !");
        closeButtonRef.current?.click();
      } else if (boostType === "standard") {
        const standardBoostData = await boostStandardClassified(payload);
        toastSuccess(
          "Your Standard Boost request has been sent successfully !"
        );
        closeButtonRef.current?.click();
      } else {
        toastWarning("Please Select a Boost type");
      }
    } catch (error: any) {
      toastError(error.response.data.message);
      console.log("error while ad boost : ", error.response.data.message);
    }
  }

  return (
    <>
      <div
        className="modal fade"
        id={`staticBackdrop_${adDetails.id}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby={`staticBackdropLabel_${adDetails.id}`}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1
                className="modal-title fs-5"
                id={`staticBackdropLabel_${adDetails.id}`}
              >
                Boost Your Ad
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {boostTypeList?.map((boost) => (
                <div key={boost.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={boostType === boost.boostType}
                      id={`checkDefault_${boost.boostType}`}
                      onChange={(e) => {
                        handleBoostTypeChange(e, boost.boostType);
                      }}
                    />
                    <label
                      className="form-check-label w-100  border-bottom"
                      htmlFor={`checkDefault_${boost.boostType}`}
                    >
                      <div className="d-flex align-items-center justify-content-between cursor-pointer fw-bold">
                        <div>{boost.title}</div>
                        <div>Rs {boost.boostPrice}</div>
                      </div>
                    </label>
                  </div>
                  <div className="mt-2">
                    <ul>
                      <li>
                        Your ad will appear on top for continuous{" "}
                        <span className="fw-bold">{boost.boostDays} days</span>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={closeButtonRef}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger text-white"
                onClick={handleAdBoost}
              >
                Boost
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdBoostPopup;
